const ProviderTypes = {
    avant: 1,
    bobcat: 2,
    auxcap: 3,
} as const;

const ApiLogsEnums = {
    aspire: 1,
    aspireapi: 2,
    stripe: 3,
    chatbot: 4,
    others: 5,
} as const;

const ClientTypes = {
    web: 1,
    mobile: 2,
    api: 3,
} as const;

export { ProviderTypes, ApiLogsEnums, ClientTypes };
